/* eslint-disable */
// @ts-nocheck
import MainDispatcher from '../support/MainDispatcher';
import type { App } from '../../common/types/appTypes';
import type { Org } from '../../common/types/orgTypes';
export default {
  _timeout: function (index: number) {
    MainDispatcher.dispatch({
      action: 'NOTIFICATION_TIMED_OUT',
      index: index,
    });
  },
  hideNotification: function (note: { index: number }) {
    MainDispatcher.dispatch({
      action: 'NOTIFICATION_HIDDEN',
      index: note.index,
    });
  },
  // Eventually, this should go away in favor of notifications on responses to events.
  showNotification: function (text: string, status: string, instrumentationText?: string) {
    MainDispatcher.dispatch({
      action: 'NOTIFICATION_SHOW',
      text,
      status,
      instrumentationText,
    });
  },
  entitySaving: () => {
    MainDispatcher.dispatch({
      action: 'ENTITY_SAVING',
    });
  },
  entitySaved: (appOrOrg: App | Org) => {
    MainDispatcher.dispatch({
      action: 'ENTITY_SAVED',
      appOrOrg,
    });
  },
  entityError: (error: string) => {
    MainDispatcher.dispatch({
      action: 'ENTITY_ERROR',
      error,
    });
  },
};
